


































































import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import VerEditarRutaModal from './VerEditarRutaModal.vue';
import ModalVerHistorial from './ModalVerHistorial.vue';
import VerCrearRutaModal from './VerCrearRutaModal.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  RowNode,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { utils, writeFileXLSX } from 'xlsx';
import moment from 'moment';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import { Accion } from '@/config/enums';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    VerEditarRutaModal,
    FormFieldsContainer,
    VerCrearRutaModal,
    ModalVerHistorial,
  },
})
export default class MantenedorTelcosBase extends ComponenteBase {
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades = Funcionalidades.MantenedorTelco;

  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  filtro: any;
  mostrarModalVerDetalle: boolean = false;
  mostrarModalCrear: boolean = false;
  //MsResponseData: MsResponseData = null;
  //MsResponseDataWidget: MsResponseDataWidget = null;
  telcoid: Number = null;
  estadoSelected: Number = null;
  telconame: string = null;
  telcoprefix: string = null;
  serverSide: any;
  gridApi: GridApi = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = '';
  ordesList: any[] = [];
  showModalMostrar: boolean = false;
  usuarioID: any = '';
  telcoid_crear: any = '';

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.ReportesSerie) {
        if (data.action === Accion.VerDetalle) {
          // Editar - Ver Detalle
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalMostrar = true;
          }
        }
      }
    });
  }

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        Id: e.telcoid,
        Nombre: e.telconame,
        Prefijo: e.telcoprefix,
        Estado: e.estado,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Telcos');
    writeFileXLSX(wb, 'Telcos.xlsx');
    this.$snotify.success('Excel Exportado con exito', 3000);
  }

  async getReportes(usuarioID: any) {
    let self = this;
    this.telcoid_crear = await fetchReportesSerie(
      { '': '' },
      'mantenedor_telco/crear_telco_id'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return Number(data.data.data.max) + 1;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
    this.loadingService.showLoading();
    return fetchReportesSerie({ usuarioID: usuarioID }, 'mantenedor_telco')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Id',
        field: 'telcoid',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Nombre',
        field: 'telconame',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 410,
      },
      {
        headerName: 'Prefijo',
        field: 'telcoprefix',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 410,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 300,
        cellRenderer: (params: any) => {
          return `<i class="material-icons"  style="width: 15px; height: 15px; margin-top: 7px; border-radius: 50%; background: ${
            params.data.estado == 'ACTIVO'
              ? 'rgb(42, 255, 78)'
              : 'rgb(255, 58, 58)'
          };"></i>
          <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${
            params.data.estado
          }</a>
          `;
        },
      },
    ],

    pagination: true,
    paginationPageSize: 25,
    onGridReady: this.handleGridReady,
  };

  handleBuscarClick() {
    this.filtroRequerimiento(true);
  }

  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  //Busca dentro del resultado de la grilla
  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar];

  constructor() {
    super();
    actionsEvent.onEditar(this.handleVerDetalleClick);
    actionsEvent.onVerHistorico(this.handleHistorialClick);
  }

  handleVerDetalleClick(params: ICellRendererParams) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).nombre;
    this.telcoid = params.data.telcoid;
    this.telconame = params.data.telconame;
    this.telcoprefix = params.data.telcoprefix;
    this.mostrarModalVerDetalle = true;
    this.estadoSelected = params.data.estado;
  }
  mostrarModalHistorial: boolean = false;
  handleHistorialClick(params: ICellRendererParams) {
    this.telcoid = params.data.telcoid;
    this.telconame = params.data.telconame;
    this.mostrarModalHistorial = true;
  }

  async handleCierreModalVerDetalle() {
    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi.setRowData(this.ordesList);
    this.mostrarModalVerDetalle = false;
  }

  async crear_estado() {
    this.mostrarModalCrear = true;
    let self = this;
    this.loadingService.showLoading();
  }
  async handleCierreModalCrear() {
    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi.setRowData(this.ordesList);
    this.mostrarModalCrear = false;
    this.mostrarModalHistorial = false;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
}
